/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/2/2022
 */
import BaseObject from "@shared/BaseObject.js";


export default class WorkflowDocuments extends BaseObject {

	getForms(){
		return []
	}

	getDocSignTemplates(){
		return []
	}
}
